import App from 'common/backbone-app';

const getEndpoint = () => App.getWebSocketsUrl();

export default getEndpoint;
